import AOS from "aos";
import "aos/dist/aos.css";
import Slider from "react-slick";
import "../../assets/css/About.css";
import img9 from "../../assets/image/AboutUs/Collaborative Spirit.jpg";
import img1 from "../../assets/image/AboutUs/img1.avif";
import img8 from "../../assets/image/AboutUs/img1.png";
import img from "../../assets/image/AboutUs/img15.jpg";
import img11 from "../../assets/image/AboutUs/img16.avif";
import l2 from "../../assets/image/Home/Clients - Logo (2).png";
import l3 from "../../assets/image/Home/Clients - Logo (3).png";
import test1 from "../../assets/image/Home/Our Games Testimonial.jpg";
// import { Star } from 'lucide-react';
import {
  ChevronLeft,
  ChevronRight,
  Package,
  Sparkles,
  Star,
  Trophy,
  Users,
} from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import data from "../../Meta/Meta_ApiUrl";
import Footer from "../Footer/Footer";

const About = () => {
  const [meta, setMeta] = useState({});

  useEffect(() => {
    // Directly access about_page from data
    const AboutMeta = data[0]?.about_page;

    // Set meta state if about Meta exists
    if (AboutMeta) {
      setMeta(AboutMeta);
    }
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);
  // eslint-disable-next-line
  const [openFeatures, setOpenFeatures] = useState([false, false, false]);
  const handleToggle = (index) => {
    setActiveIndex(index);
  };

  // eslint-disable-next-line
  const toggleFeature = (index) => {
    setOpenFeatures((prev) => prev.map((val, i) => (i === index ? !val : val)));
  };

  const styles = {
    section: {
      // backgroundColor: "#f8f9fa",
      minHeight: "70vh",
      paddingTop: "2rem",
      paddingBottom: "1rem",
      marginTop: "20px",
    },
    featureItem: {
      marginBottom: "1.5rem",
    },
    activeCircle: {
      width: "32px",
      height: "32px",
      backgroundColor: "#00b7eb",
      borderRadius: "50%",

      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      marginTop: "0.25rem",
    },
    inactiveCircle: {
      width: "32px",
      height: "32px",
      border: "2px solid #00b7eb",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      marginTop: "0.25rem",
    },
    activeDot: {
      width: "8px",
      height: "8px",
      backgroundColor: "white",
      borderRadius: "50%",
    },
    inactiveLine: {
      width: "16px",
      height: "2px",
      backgroundColor: "#00b7eb",
    },
    featureTitle: {
      fontSize: "24px",
      fontWeight: "700",
      color: "#2d3436",
      marginBottom: "0.5rem",
    },
    featureDesc: {
      color: "#050708",
      fontWeight: "semibold",
      lineHeight: "1.6",
      fontSize: "clamp(0.9rem, 2vw, 1rem)",
    },
  };

  const keyframes = `
    @keyframes bounce {
      0%, 20%, 53%, 80%, 100% {
        transform: translate3d(0,0,0);
      }
      40%, 43% {
        transform: translate3d(0,-15px,0);
      }
      70% {
        transform: translate3d(0,-7px,0);
      }
      90% {
        transform: translate3d(0,-2px,0);
      }
    }

    @keyframes pulse {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.05);
      }
      100% {
        transform: scale(1);
      }
    }
  `;
  // eslint-disable-next-line
  const [isHovered, setIsHovered] = React.useState(false);
  // eslint-disable-next-line
  const [isVisible, setIsVisible] = useState(false);
  const [expandedItem, setExpandedItem] = useState(null);
  const [animatedCards, setAnimatedCards] = useState([]);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);
  // eslint-disable-next-line
  const handleCardAnimation = (index) => {
    if (!animatedCards.includes(index)) {
      setAnimatedCards([...animatedCards, index]);
    }
  };
  // eslint-disable-next-line
  const experiences = [
    {
      id: 1,
      title: "Top notch quality",
      icon: <Star className="w-6 h-6" />,
      content:
        "We deliver premium gaming experiences with cutting-edge graphics, seamless performance, and attention to every detail. Our quality standards ensure players get the best possible gaming experience every time they play.",
      color: "from-yellow-400 to-orange-500",
    },
    {
      id: 2,
      title: "Extensive experience",
      icon: <Users className="w-6 h-6" />,
      content:
        "With over 14 years in game development, we bring deep industry knowledge and proven expertise to every project. Our team has successfully delivered hundreds of gaming solutions across various platforms and genres.",
      color: "from-blue-400 to-purple-500",
    },
    {
      id: 3,
      title: "Client centric approach",
      icon: <Sparkles className="w-6 h-6" />,
      content:
        "Every project begins with understanding your unique vision and requirements. We work closely with clients throughout the development process, ensuring transparent communication and delivering solutions that exceed expectations.",
      color: "from-green-400 to-teal-500",
    },
    {
      id: 4,
      title: "Full package product",
      icon: <Package className="w-6 h-6" />,
      content:
        "From initial concept to post-launch support, we provide comprehensive gaming solutions. Our full-stack approach includes game design, development, testing, deployment, and ongoing maintenance for complete peace of mind.",
      color: "from-pink-400 to-red-500",
    },
    {
      id: 5,
      title: "Outstanding end result",
      icon: <Trophy className="w-6 h-6" />,
      content:
        "Our portfolio speaks for itself with award-winning games and satisfied clients worldwide. We consistently deliver exceptional results that drive engagement, retention, and business success for our partners.",
      color: "from-indigo-400 to-blue-500",
    },
  ];
  // eslint-disable-next-line
  const toggleExpand = (id) => {
    setExpandedItem(expandedItem === id ? null : id);
  };

  const strengthsData = [
    {
      icon: (
        <svg
          width="60"
          height="60"
          viewBox="0 0 100 100"
          fill="nfont-para-about"
        >
          <circle cx="50" cy="35" r="20" fill="#FFD700" opacity="0.3" />
          <path
            d="M50 15 C40 15 32 23 32 33 C32 40 36 46 42 48 L42 55 C42 57 44 59 46 59 L54 59 C56 59 58 57 58 55 L58 48 C64 46 68 40 68 33 C68 23 60 15 50 15 Z"
            fill="#FFD700"
          />
          <rect x="44" y="62" width="12" height="4" rx="2" fill="#8B4513" />
          <rect x="46" y="68" width="8" height="2" rx="1" fill="#8B4513" />
          <g className="animate-pulse">
            <path
              d="M50 5 L50 10"
              stroke="#FFD700"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M71 14 L68 17"
              stroke="#FFD700"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M86 35 L81 35"
              stroke="#FFD700"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M71 56 L68 53"
              stroke="#FFD700"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M29 14 L32 17"
              stroke="#FFD700"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M14 35 L19 35"
              stroke="#FFD700"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M29 56 L32 53"
              stroke="#FFD700"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </g>
        </svg>
      ),
      title: "Innovation at the Core",
      desc: "We continually explore emerging technologies and stay ahead of industry trends, ensuring our solutions are both modern and future-proof.",
    },
    {
      icon: (
        <svg
          width="60"
          height="60"
          viewBox="0 0 100 100"
          fill="nfont-para-about"
        >
          <circle
            cx="50"
            cy="50"
            r="30"
            fill="nfont-para-about"
            stroke="#FF69B4"
            strokeWidth="3"
          />
          <circle
            cx="50"
            cy="50"
            r="20"
            fill="nfont-para-about"
            stroke="#FF69B4"
            strokeWidth="2"
          />
          <circle cx="50" cy="50" r="10" fill="#FF69B4" />
          <circle cx="50" cy="50" r="3" fill="white" />
          <g className="animate-bounce">
            <path
              d="M20 30 L45 45"
              stroke="#00BFFF"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              d="M38 40 L45 45 L40 52"
              stroke="#00BFFF"
              strokeWidth="3"
              strokeLinecap="round"
              fill="nfont-para-about"
            />
          </g>
        </svg>
      ),
      title: "Build for Impact",
      desc: "Our solutions are designed to solve real-world problems and deliver measurable business value."
    },
    // },
    {
      icon: (
        <svg
          width="60"
          height="60"
          viewBox="0 0 100 100"
          fill="nfont-para-about"
        >
          <defs>
            <linearGradient id="lightning" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FF4500" />
              <stop offset="100%" stopColor="#FFD700" />
            </linearGradient>
          </defs>
          <path
            d="M45 10 L35 40 L50 40 L40 90 L60 50 L45 50 L55 10 Z"
            fill="url(#lightning)"
          />
          <g className="animate-ping">
            <circle cx="30" cy="25" r="2" fill="#FFD700" opacity="0.7" />
            <circle cx="70" cy="35" r="1.5" fill="#FF4500" opacity="0.8" />
            <circle cx="25" cy="60" r="1" fill="#FFD700" opacity="0.6" />
            <circle cx="75" cy="70" r="2" fill="#FF4500" opacity="0.7" />
          </g>
        </svg>
      ),
      title: "Speed & Agility",
      desc: "We adapt quickly to changing requirements and deliver fast, scalable solutions.",
    },
    {
      icon: (
        <svg
          width="60"
          height="60"
          viewBox="0 0 100 100"
          fill="nfont-para-about"
        >
          <defs>
            <radialGradient id="handGlow">
              <stop offset="0%" stopColor="#FFD700" stopOpacity="0.3" />
              <stop offset="100%" stopColor="#FFD700" stopOpacity="0" />
            </radialGradient>
          </defs>
          <circle cx="50" cy="50" r="35" fill="url(#handGlow)" />
          <path
            d="M25 45 C25 40 28 35 35 35 L40 35 C45 35 50 40 50 45 L50 50 C50 55 55 60 60 60 L65 60 C72 60 75 55 75 50 C75 45 70 40 65 40 L60 40"
            stroke="#FFD700"
            strokeWidth="4"
            fill="nfont-para-about"
            strokeLinecap="round"
          />
          <path
            d="M50 50 L60 40"
            stroke="#FFD700"
            strokeWidth="4"
            strokeLinecap="round"
          />
          <g className="animate-pulse">
            <circle cx="35" cy="42" r="2" fill="#FFD700" />
            <circle cx="65" cy="47" r="2" fill="#FFD700" />
            <circle cx="50" cy="45" r="1.5" fill="#FFD700" />
          </g>
        </svg>
      ),
      title: "Precision & Quality",
      desc: "We ensure accuracy, reliability, and high-quality standards in every project we deliver.",
    },
  ];

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 50,
      easing: "ease-in-out",
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  //  const [currentSlide1, setcurrentSlide1] = useState(0);

  const testimonialsPrev = [
    {
      id: 1,
      name: "SIDDHARTH",
      role: "Founder Kreativation Studio",
      image: l2,
      quote:
        "I can tell how hard you've worked to be more collaborative during meetings. Your ideas are more powerful than they used to be. You've come a long way, and the team is better for it.",
      rating: 5,
    },
    {
      id: 2,
      name: "HARRY SINGH",
      role: "Founder Polc Management",
      image: l3,
      quote:
        "Very quick respond and resolve. Happy with the job. Such efficient and professional services. Excellent work and very quick turn around, Keep up the good work.",
      rating: 5,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    autoplay: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768, // md
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const renderStarsPrev = (rating) => {
    return [...Array(5)].map((_, i) => (
      <i
        key={i}
        className={`bi ${i < rating ? "bi-star-fill text-warning" : "bi-star text-secondary"
          }`}
      />
    ));
  };

  const [currentSlide1, setcurrentSlide1] = useState(0);

  const testimonialsnew = [
    {
      id: 1,
      name: "ANDRU SMITH",
      role: "Boxing Trainer",
      image:
        "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=150&h=150&fit=crop&crop=face",
      quote:
        "We teach martial arts because we love it — not because we want anything from you. Unlike other martial arts programs",
      rating: 5,
    },

    {
      id: 3,
      name: "MIKE TYSON",
      role: "Professional Boxer",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      quote:
        "The training here is intense and professional. Every session pushes you to your limits and beyond. ",
      rating: 5,
    },
    {
      id: 4,
      name: "SARAH CONNOR",
      role: "Fitness Trainer",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      quote:
        "Amazing facility with top-notch equipment. The trainers are professional and really care about your progress.",
      rating: 5,
    },
    {
      id: 5,
      name: "JOHN WARRIOR",
      role: "MMA Fighter",
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      quote:
        "Best martial arts school in the city. The techniques taught here are authentic and effective for real combat.",
      rating: 5,
    },
    {
      id: 6,
      name: "LISA POWER",
      role: "Kickboxing Instructor",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
      quote:
        "The community here is incredible. Everyone supports each other and the training is world-class.",
      rating: 5,
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setcurrentSlide1((prev) => (prev + 1) % testimonialsnew.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [testimonialsnew.length]);

  const sliderRef = useRef();

  const prevSlidenew = () => {
    sliderRef.current?.slickPrev();
  };

  const nextSlidenew = () => {
    sliderRef.current?.slickNext();
  };

  const goToSlidenew = (index) => {
    setcurrentSlide1(index);
  };

  const renderStarsnew = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        size={16}
        className={i < rating ? "text-warning" : "text-muted"}
        fill={i < rating ? "currentColor" : "none"}
      />
    ));
  };

  const getVisibletestimonialsnew = () => {
    const visible = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentSlide1 + i) % testimonialsnew.length;
      visible.push(testimonialsnew[index]);
    }
    return visible;
  };

  return (
    <HelmetProvider>
      <div style={{ overflowX: "hidden" }}>
        <Helmet>
          <title>{meta?.title || "About Us - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED"}</title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Based in Salem, we’ve successfully trained over 2,000 learners since 2020, equipping them with the knowledge and confidence to thrive in today’s fast-paced tech industry."
            }
          />
        </Helmet>

        {/* Hero Section - Responsive */}
        <div
          className="position-relative min-vh-50 about-bg d-flex align-items-center justify-content-center bg-dark text-white"
          style={{ overflowX: "hidden", width: "100%" }}
        >
          <div className="container position-relative px-3 px-md-4">
            <div className="row align-items-center">
              <div className="col-12 about-content">
                <nav
                  aria-label="breadcrumb"
                  className="mb-3 mb-md-4"
                  data-aos="fade-right"
                  data-aos-delay="100"
                >
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a
                        href="/"
                        className="text-white fw-bold text-decoration-nfont-para-about"
                      >
                        Home
                      </a>
                    </li>
                    <li className="breadcrumb-item fw-bold" aria-current="page">
                      About Us
                    </li>
                  </ol>
                </nav>
                <h3
                  className="display-5 display-md-5 fw-bold mb-3 ms-0 text-md-start"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  About Us
                </h3>
              </div>
            </div>
          </div>
        </div>

        {/* About Us Section - Responsive */}
        <section className="p-md-2 bg-light py-2">
          <div className="container px-3 px-md-4 mt-4">
            <div className="row align-items-start">
              {/* Align at top on larger screens */}
              {/* LEFT SIDE - TEXT */}
              <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                <h3
                  className="display-5 fw-bold mb-3 text-center text-lg-start"
                  data-aos="fade-right"
                  data-aos-delay="100"
                >
                  About <span className="font-red">Us</span>
                </h3>
                <p
                  className="font-para-about text-wrap text-lg-start"
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  At <strong>SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED</strong>, we are a forward-thinking technology company focused on delivering innovative solutions in Drone Technology, Artificial Intelligence (AI), Internet of Things (IoT), and Robotics.

                  We specialize in building smart, efficient, and future-ready systems that help industries adapt to the rapidly evolving digital landscape. From aerial intelligence and smart automation to connected systems and AI-driven applications, we provide end-to-end technology solutions tailored to real-world needs.
                </p>
                <p
                  className="font-para-about text-wrap text-lg-start"
                  data-aos="fade-right"
                  data-aos-delay="300"
                >
                  Our core strength lies in transforming complex challenges into simple, effective solutions. We support industries with advanced drone services, intelligent automation, and customized technology systems that improve efficiency, reduce risks, and drive innovation.

                  We are not just service providers — we are technology partners committed to shaping the future through expertise, innovation, and purpose-driven solutions.
                </p>
              </div>
              {/* RIGHT SIDE - IMAGE + CARDS */}
              <div className="col-12 col-lg-6 d-flex flex-column align-items-center">
                {/* IMAGE */}
                <div
                  className="w-100 mb-4"
                  data-aos="fade-left"
                  data-aos-delay="200"
                >
                  <img
                    src={img}
                    className="img-fluid rounded-3 shadow"
                    alt="Game screenshot"
                    style={{
                      maxHeight: "350px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>

                {/* CARDS */}
                <div className="row g-3 w-100">
                  <div className="col-md-6 d-flex">
                    <div
                      className="card p-4 shadow-lg border-0 w-100 "
                      style={{
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                        borderRadius: "15px",
                        height: "90%",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          width: "4px",
                          height: "100%",
                          background: "#00b7eb",
                        }}
                      ></div>
                      <h3 className="mb-0">
                        <b className="font-red">14+ years</b>
                        <br />
                        <span className="fs-5 fw-bold">
                          Hands-On Experience
                        </span>
                      </h3>
                    </div>
                  </div>

                  <div className="col-md-6 d-flex">
                    <div
                      className="card p-4 shadow-lg border-0 w-100"
                      style={{
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                        borderRadius: "15px",
                        height: "90%",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          width: "4px",
                          height: "100%",
                          background: "#00b7eb",
                        }}
                      ></div>
                      <p className="mb-0 fw-bold">
                        Our company has rapidly evolved into a dynamic leader in
                        the IT solutions industry.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Core Strengths Section - Responsive */}
        <section
          className=" font-black py-2 py-md-2 py-sm-2 position-relative overflow-hidden"
          style={{ marginTop: "20px" }}
        >
          <div className="container px-3 px-md-4">
            <div className="row align-items-center">
              {/* Left Content */}
              <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                <h3 className="display-5 display-md-5 fw-bold font-black mb-3 text-center text-md-start">
                  Core strengths <br />
                  <span className="font-red">& Values</span>
                </h3>
                <p className="font-para-about text-center text-md-start">
                  Our core strengths lie in innovation, reliability, and
                  customer satisfaction — values that drive everything we
                  create.
                </p>

                <div className="row mt-4 gy-3 gy-md-4">
                  {strengthsData.map((strength, idx) => (
                    <div
                      className="col-12 col-sm-6"
                      key={idx}
                      data-aos={
                        ["fade-up", "fade-down", "fade-right", "fade-left"][idx]
                      }
                      data-aos-delay={100 * (idx + 1)}
                      data-aos-duration="800"
                    >
                      <div
                        className="bg-white font-black rounded-3 p-3 p-md-4 h-100 text-center text-md-start position-relative"
                        style={{
                          borderTop: "3px solid transparent",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) =>
                        (e.currentTarget.style.borderTop =
                          "3px solid #00b7eb")
                        }
                        onMouseLeave={(e) =>
                        (e.currentTarget.style.borderTop =
                          "3px solid transparent")
                        }
                      >
                        <div
                          className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3 mx-auto mx-md-0"
                          style={{
                            width: "60px",
                            height: "60px",
                            backgroundColor: "white",
                          }}
                        >
                          {strength.icon}
                        </div>
                        <h6 className="font-black fs-4 fs-md-5 fw-bold mb-2">
                          {strength.title}
                        </h6>
                        <p className="font-para-about mb-0">{strength.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Right: Images - Responsive */}
              {/* <div
              className="col-12 col-lg-6 image-container-row"
              data-aos="zoom-in"
              data-aos-delay="500"
              data-aos-duration="1000"
            >
              {[img9, img8].map((img, i) => (
                <div key={i} className="custom-image-wrapper">
                  <img src={img} alt={`image-${i}`} className="custom-image" />
                </div>
              ))}
            </div> */}

              <div
                className="col-12 col-lg-6 image-container-row d-none d-lg-block"
                data-aos="zoom-in"
                data-aos-delay="500"
                data-aos-duration="1000"
              >
                <div className="row">
                  {[img8, img9].map((img, i) => (
                    <div
                      key={i}
                      className="col-6 d-flex justify-content-center align-items-center"
                    >
                      <div className="custom-image-wrapper">
                        <img
                          src={img}
                          alt={`image-${i}`}
                          className="custom-image"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Vision for the Future Section - Responsive */}
        <section
          className="py-5 py-md-5 bg-light"
          style={{ marginTop: "40px" }}
        >
          <div className="container px-3 px-md-4">
            <div className="row g-4 align-items-center">
              {/* Text Column */}
              <div
                className="col-12 col-lg-6 d-flex align-items-center order-1 order-lg-2"
                data-aos="fade-right"
                data-aos-delay="100"
              >
                <div className="text-lg-start px-2 px-md-4">
                  <h3 className="display-5 fw-bold mb-3">
                    Vision for the <span className="font-red">Future</span>
                  </h3>
                  <p className="font-para-about mb-0">
                    Our vision is to power the future with smart, connected, and autonomous technologies that redefine how the world works, moves, and grows.

                    We aim to lead innovation in Drone Technology, AI, IoT, and Robotics by building scalable, intelligent systems that create real-world impact across industries.
                  </p>
                </div>
              </div>

              {/* Image Column */}
              <div
                className="col-12 col-lg-6 order-2 order-lg-1"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <div className="position-relative overflow-hidden rounded-3 shadow-sm h-100">
                  <img
                    src={img1}
                    className="w-100 h-100 object-fit-cover"
                    style={{ minHeight: "300px", maxHeight: "500px" }}
                    alt="VR Technology"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Ongoing Mission Section - Responsive */}
        <style>{keyframes}</style>
        <section style={styles.section}>
          <div className=" container px-3 px-md-4 ">
            <div className="row align-items-center">
              {/* Left Side - Content */}
              <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                <div className="mb-3">
                  <button
                    className=" btn border d-flex border-danger fw-semibold  bg-transparent  px-3 py-2 rounded-pill fs-6 fs-md-5"
                    style={{ color: "#00b7eb" }}
                  >
                    OUR BENEFITS
                  </button>
                </div>
                <h3 className="display-5 display-md-5 fw-bold text-lg-start">
                  Ongoing <span className="font-red">Mission</span>
                </h3>

                {/* Features List */}
                <div className="mt-4">
                  {[
                    {
                      title: "Simplifying Complexity",
                      desc: "We build intelligent solutions in drones, AI, IoT, and robotics that simplify complex operations and improve efficiency.",
                    },
                    {
                      title: "Accelerating Innovation",
                      desc: "Our focus is on delivering fast, scalable, and future-ready technologies that help businesses stay ahead.",
                    },
                    {
                      title: "Real-World Impact",
                      desc: "We create practical, data-driven solutions that solve real challenges across industries like construction, agriculture, and infrastructure.",
                    },
                  ].map((item, i) => (
                    <div className="d-flex" key={i} style={styles.featureItem}>
                      {/* Left icon button (dot/line) */}
                      <button
                        onClick={() => handleToggle(i)}
                        className="me-3"
                        style={{
                          ...styles[
                          activeIndex === i
                            ? "activeCircle"
                            : "inactiveCircle"
                          ],
                          border: "nfont-para-about",
                          cursor: "pointer",
                          padding: 0,
                          outline: "nfont-para-about",
                          backgroundColor:
                            activeIndex === i ? "#00b7eb" : "transparent",
                        }}
                      >
                        {activeIndex === i ? (
                          <div style={styles.activeDot}></div>
                        ) : (
                          <div style={styles.inactiveLine}></div>
                        )}
                      </button>

                      {/* Right Content */}
                      <div className="flex-grow-1">
                        <div
                          className="d-flex justify-content-between align-items-center"
                          onClick={() => handleToggle(i)}
                          style={{ cursor: "pointer" }}
                        >
                          <h5 style={styles.featureTitle} className="mb-0">
                            {item.title}
                          </h5>
                        </div>

                        {activeIndex === i && (
                          <p
                            style={styles.featureDesc}
                            className="mt-2 font-para-about"
                          >
                            {item.desc}
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-lg-6 d-flex justify-content-center align-items-center overflow-hidden">
                <div className="global-orbit-wrapper">
                  <div className="global-orbit-container">
                    <img
                      src={img11}
                      alt="ongoing mission"
                      className="global-orbiting-img rounded-3"
                      style={{ maxWidth: "100%", height: "100%" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* What we do*/}
        <section
          className="py-5 py-md-5 bg-light"
          style={{ marginTop: "40px" }}
        >
          <div className="container px-3 px-md-4">
            <div className="row g-4 align-items-center">
              {/* Text Column */}
              <div
                className="col-12 col-lg-6 d-flex align-items-center order-1 order-lg-2"
                data-aos="fade-right"
                data-aos-delay="100"
              >
                <div className="text-lg-start px-2 px-md-4">
                  <h3 className="fw-bold mt-4">What We Do</h3>
                  <ul className="font-para-about">
                    <li>Drone Services – Survey, Inspection, Mapping</li>
                    <li>Drone Training & Education Programs</li>
                    <li>Robotics Development & Prototyping</li>
                    <li>IoT Solutions & Smart Systems</li>
                    <li>AI Development & Automation</li>
                    <li>Web & App Development</li>
                    <li>AR & VR Applications</li>
                  </ul>
                </div>
              </div>

              {/* Image Column */}
              <div
                className="col-12 col-lg-6 order-2 order-lg-1"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <div className="position-relative overflow-hidden rounded-3 shadow-sm h-100">
                  <img
                    src={img1}
                    className="w-100 h-100 object-fit-cover"
                    style={{ minHeight: "300px", maxHeight: "500px" }}
                    alt="VR Technology"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Join Our Innovation Journey Section */}
        {/* <section
        className="position-relative overflow-hidden"
        style={{
          background: "light",
          minHeight: "100vh",
        }}
      >
       
        <div className="container position-relative z-3 py-5">
          <div className="row align-items-center min-vh-75">
            
            <div
              className="col-12 col-lg-6 text-center mb-5 mb-lg-0"
              data-aos="fade-up"
            >
              <div className="position-relative text-center">
                <img
                  src={img10}
                  className="img-fluid responsive-img"
                  alt="Trusted Partner"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              </div>
            </div>

            <div className="col-12 col-lg-6" data-aos="fade-left">
              <div className="text-white">
                <h3 className="display-5 font-black fw-bold mb-4">
                  Play Smart. Win Big.
                  <br />
                  <span className="font-red">The Game Starts Here!</span>
                </h3>

                <p className="font-para-about">
                  Explore SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED — your trusted destination for Ludo, Rummy,
                  Teen Patti & Casino platforms. Dive into immersive real cash
                  games powered by innovation and experience.
                </p>

                <a
                  href="/services"
                  className="btn btn-red text-white fw-semibold px-4 py-2"
                >
                  Read More →
                </a>
              </div>
            </div>
          </div>
        // </div>

        
        <style>{`
          @keyframes scrollText {
            0% {
              transform: translateX(100%);
            }
            100% {
              transform: translateX(-100%);
            }
          }

          @keyframes float {
            0%,
            100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-20px);
            }
          }

          .min-vh-75 {
            min-height: 75vh;
          }
        `}</style>
      </section> */}
        <style>{`
          @keyframes float {
            0% {
              transform: translateY(0px);
            }
            100% {
              transform: translateY(-20px);
            }
          }

          .hover-scale {
            transition: transform 0.3s ease;
          }

          .hover-scale:hover {
            transform: scale(1.05);
          }

          .backdrop-blur {
            backdrop-filter: blur(10px);
          }
        `}</style>

        <div
          className="container-fluid bg-light py-4"
          style={{ marginTop: "30px" }}
        >
          <div className="container " data-aos="fade-up">
            <div className=" d-flex ">
              <span
                className=" btn border border-danger d-flex fw-semibold  bg-transparent mt-2 mb-2 px-3 py-2 rounded-pill fs-6 fs-md-5"
                style={{ color: "#00b7eb" }}
              >
                TESIMONIAL
              </span>
            </div>

            <div
              className=" py-2 boxer-testimonial-container"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <div className="container">
                {/* Header */}
                <div className="row mb-5">
                  <div className="col-lg-8">
                    <h3
                      className="display-5 fw-bold fs-2 fs-sm-3 fs-md-3 responsive-heading text-uppercase mb-4"
                      style={{ fontSize: "3.5rem", letterSpacing: "2px" }}
                    >
                      OUR <span style={{ color: "#dc3545" }}>TESTIMONIAL</span>{" "}
                    </h3>
                    <p
                      className="font-para-about mb-0"
                      style={{ fontSize: "1.1rem", lineHeight: "1.6" }}
                    >
                      "Our collaboration with Shiv Nextgen Technologies transformed our operations. Their drone and AI solutions improved efficiency, accuracy, and decision-making across our projects."
                    </p>
                  </div>
                  <div className="col-lg-4  mt-2 d-flex align-items-center justify-content-end">
                    <button
                      className="btn rounded-circle border me-3 d-flex align-items-center justify-content-center"
                      onClick={prevSlidenew}
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: "white",
                        borderColor: "#dc3545",
                        color: "#00b7eb",
                      }}
                    >
                      <ChevronLeft size={24} />
                    </button>
                    <button
                      className="btn rounded-circle border d-flex align-items-center justify-content-center"
                      onClick={nextSlidenew}
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: "white",
                        borderColor: "#dc3545",
                        color: "#00b7eb",
                      }}
                    >
                      <ChevronRight size={24} />
                    </button>
                  </div>
                </div>

                {/* Main Content */}
                <div className="container">
                  <div className="row g-2 align-items-stretch">
                    {/* Testimonials Slider */}
                    <div className="col-12 col-lg-8">
                      <Slider {...settings} ref={sliderRef}>
                        {testimonialsPrev.map((testimonial) => (
                          <div key={testimonial.id} className="px-2 h-100">
                            <div className="bg-white p-3 shadow-sm rounded-3 h-100 d-flex flex-column justify-content-between">
                              {/* Quotation icon */}
                              <div className="mb-3">
                                <i className="bi bi-quote fs-1 font-red"></i>
                              </div>

                              {/* Testimonial text */}
                              <p className="fs-6 font-black flex-grow-1">
                                {testimonial.quote}
                              </p>

                              {/* Footer */}
                              <div className="d-flex align-items-center mt-3">
                                <img
                                  src={testimonial.image}
                                  alt={testimonial.name}
                                  className="rounded-circle me-3"
                                  width={50}
                                  height={50}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = `https://via.placeholder.com/70x70/dc3545/ffffff?text=${testimonial.name?.charAt(
                                      0
                                    )}`;
                                  }}
                                />
                                <div className="flex-grow-1">
                                  <h6 className="mb-0">{testimonial.name}</h6>
                                  <small className="text-muted d-block">
                                    {testimonial.role}
                                  </small>
                                  <div className="d-flex gap-1 mt-1">
                                    {renderStarsPrev(testimonial.rating)}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    </div>

                    {/* Side Image */}
                    <div className="col-12 col-lg-4 d-none d-lg-block">
                      <div className="h-100 min-vh-25 position-relative">
                        <div className="rounded-3 overflow-hidden h-100 bg-black">
                          <img
                            src={test1}
                            alt="Master Upper Cut"
                            className="img-fluid w-100 h-100"
                            style={{ objectFit: "cover" }}
                            onError={(e) => {
                              e.target.src =
                                "https://via.placeholder.com/400x600/000000/dc3545?text=BOXER";
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*  
      <style>{`
        .testimonial-card {
          min-height: 400px;
          transition: all 0.5s ease-in-out;
          animation: slideIn 0.5s ease-in-out;
        }

        .testimonial-card:hover {
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
          transform: translateY(-5px);
        }

        .testimonial-img {
          width: 60px;
          height: 60px;
          object-fit: cover;
          border: 2px solid #f8f9fa;
        }

        .quote-shape {
          width: 50px;
          height: 35px;
          background-color: #dc3545;
          clip-path: polygon(0 0, 100% 0, 85% 100%, 0% 100%);
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @media (max-width: 991px) {
          .col-lg-4 {
            margin-top: 2rem;
          }
        }

        @media (max-width: 767px) {
          .col-md-4 {
            margin-bottom: 1rem;
          }
        }
      `}</style> */}
            </div>

            {/* <div
            className="position-relative bg-light bg-gradient rounded shadow overflow-hidden"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="d-none d-md-flex min-vh-50">
              <div className="col-md-5 overflow-hidden">
                <img
                  src={currentTestimonial.image}
                  alt={currentTestimonial.name}
                  className="img-fluid h-100 w-100 object-fit-cover"
                />
                <div className="position-absolute top-0 start-0 w-100 h-100 bg-gradient"></div>
              </div>

              <div className="col-md-7 p-5 d-flex flex-column justify-content-center">
                <div className="mb-4 d-flex">
                  {[...Array(currentTestimonial.rating)].map((_, i) => (
                    <Star key={i} className="me-1 text-warning" />
                  ))}
                </div>

                <blockquote className="blockquote fs-6 fw-semibold text-muted mb-4">
                  “{currentTestimonial.review}”
                </blockquote>

                <div>
                  <div className="fw-bold fs-5 text-dark">
                    {currentTestimonial.name}
                  </div>
                  <div className="text-dark">
                    {currentTestimonial.role} at {currentTestimonial.company}
                  </div>
                </div>
              </div>
            </div>

            <div className="d-block d-md-none">
              <div className="position-relative" style={{ height: "300px" }}>
                <img
                  src={currentTestimonial.image}
                  alt={currentTestimonial.name}
                  className="w-100 h-100 object-fit-cover"
                />
                <div className="position-absolute top-0 start-0 w-100 h-100 bg-gradient"></div>
              </div>

              <div className="p-4 text-center">
                <div className="mb-3 d-flex justify-content-center">
                  {[...Array(currentTestimonial.rating)].map((_, i) => (
                    <Star key={i} className="me-1 text-warning" />
                  ))}
                </div>

                <blockquote className="blockquote fs-5 text-dark mb-3">
                  “{currentTestimonial.review}”
                </blockquote>

                <div>
                  <div className="fw-bold text-dark">
                    {currentTestimonial.name}
                  </div>
                  <div className="text-dark">
                    {currentTestimonial.role} at {currentTestimonial.company}
                  </div>
                </div>
              </div>
            </div>

            <button
              onClick={prevSlide}
              className="btn btn-light position-absolute top-50 start-0 translate-middle-y ms-2 shadow rounded-circle"
              aria-label="Previous"
            >
              <ChevronLeft />
            </button>

            <button
              onClick={nextSlide}
              className="btn btn-light position-absolute top-50 end-0 translate-middle-y me-2 shadow rounded-circle"
              aria-label="Next"
            >
              <ChevronRight />
            </button>
          </div>

          <div className="d-flex justify-content-center mt-4 gap-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`rounded-circle border-0 p-1 ${
                  index === currentIndex
                    ? "bg-primary opacity-100"
                    : "bg-secondary opacity-50"
                }`}
                style={{ width: "12px", height: "12px" }}
                aria-label={`Go to testimonial ${index + 1}`}
              ></button>
            ))}
          </div> */}
          </div>
        </div>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default About;
